import _axios from "../../libs/axios";

export default (context) => {

  let roles = [];

  _axios.get('admGroup/getTypes')
  .then(r => {
      roles = r.data.Results     
  });

  return {
    config: {
      pageSize: 40,
      remap: (r) =>{
        if (r.status >= 0) {
          r.data.Results = r.data.Results.map(item => {
            const role = roles.find(role => role.ID === item.alterType);
            if (role)item.alterType = role.name;
            return item;
          });
        }
        return r;
      }
    },

    actions: {
      create: {
        reloadGrid: true
      },
      edit: {
        reloadGrid: true
      },
      delete: true,
      print: false,
      export: true
    },

    filter: {
      fields: [
        {
          name: "alterType",
          value: 5,
          type: "select",
          label: "Rol en curso/sección",
          opts: {
            style: 'float-label',
            path: "/admGroup/getTypes?pick=true"
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "Grado",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: null,
          type: "select",
          label: "Sección",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          }
        },
        {
          name: "activityId",
          value: null,
          type: "select",
          label: "Curso",
          opts: {
            style: 'float-label',
            path: () => { return "/admSubject/get?pick=true&superSectionId=" + context.state.formFilter.superSectionId }
          }
        },
        {
          name: "userId",
          value: null,
          type: "select",
          label: "Usuario",
          opts: {
            style: 'float-label',
            searchOnline: true,
            path: "/admStaff/get?pick=true",
            withImg: true
          }
        },

        {
          name: "groupId",
          value: null,
          type: "select",
          label: "Grupo / tipo de usuario",
          opts: {
            style: 'float-label',
            path: "/admGroup/get?pick=true&staff=1"
          }
        }
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => true,
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.userId = { value: r.data.userId, label: r.data.userName }
        }
        return r
      },
      fields: [
        {
          col: 12,
          name: "userId",
          value: "",
          type: "select",
          label: "Maestro / instructor",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admStaff/get?pick=true"
          }
        },
        {
          col: 12,
          name: "role",
          value: null,
          type: "text",
          label: "Rol en curso/sección",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          name: "alterType",
          value: "",
          col: 12,
          type: "select",
          label: "Tipo de rol",
          opts: {
            style: 'float-label',
            path: "/admGroup/getTypes?pick=true",
            isMulti: false,
            tooltip: true
          }
        }
      ]      
    },

    columns: [
      {
        Header: "ID",
        accessor: "ID",
        maxWidth: 40
      },
      {
        Header: "Nombres",
        accessor: "name"
      },
      {
        Header: "Rol en curso/sección",
        accessor: "alterTypeName"
      },
      {
        Header: "Curso",
        accessor: "subject"
      },
      {
        Header: "Sección",
        accessor: "section"
      },
      {
        Header: "Grupo",
        accessor: "group"
      },
    ]
  }
}